import { langType } from './lang-base';

export const lang: langType = {
  title: 'VUE H5开发模板',
  tabbar: {
    home: '首页',
    list: '列表',
    member: '我的',
    demo: '示例',
  },
  language: {
    en: '英文',
    zh: '中文',
  },
  introduction: '一个快速开发vue3的移动端模板',
  home: {
    support: '支持',
    cssMultiLanguage: 'css图片多语言',
  },
  list: {
    details: '列表详情',
  },
  btn: {
    confirm: '确认',
    cancel: '取消',
  },
  member: {
    nicknamePlaceholder: '昵称',
    contactLabel: '联系方式：',
    contactFallback: '个人其他信息，后续补充....',
    changePassword: '修改密码',
    uploadAvatar: '上传头像',
    logs: '日志',
    logout: '退出登录',
    logoutQuestion: '确定要退出登录吗？',
    cancel: '取消',
    fetchUserInfoFailed: '获取用户信息失败',
    fetchUserInfoError: '获取用户信息异常',
  },
  common: {
    and: '和',
    agreePolicy: '同意协议',
    rememberPassword: '记住密码',
    // 认证页面共用文本
    phoneLabel: '手机号',
    phonePlaceholder: '请输入手机号',
    passwordLabel: '密码',
    passwordPlaceholder: '请输入密码',
    agreement: '已阅读并同意',
    userAgreement: '用户协议',
    privacyPolicy: '隐私政策',
    phoneRequired: '请输入手机号',
    passwordRequired: '请输入密码',
    passwordLength: '密码长度为6-20位',
    confirmPasswordLabel: '确认密码',
    confirmPasswordPlaceholder: '请输入确认密码',
    confirmPasswordRequired: '请确认密码',
    passwordNotMatch: '两次输入的密码不一致',
    agreementRequired: '请先阅读并同意《用户协议》和《隐私政策》',
    agreementRequiredSingleScode: '为实现拍照、扫码、上传图片等功能，本应用需要使用您的相机权限。请先阅读并同意《用户协议》和《隐私政策》',
    loading: '正在登录...',
    // 验证码相关
    verificationCodePlaceholder: '请输入验证码',
    getVerificationCode: '获取验证码',
    verificationCodeRequired: '请输入验证码',
    verificationCodeInvalid: '验证码格式不正确',
    // copyright: '© 2025 点3科技 技术支持',
    copyright:'© 陕西点三信息技术有限公司',
    appTitle: '管理系统',
    loadingInProgress: '加载中',
    loginExpired: '登录已过期，请重新登录',
    menuLoadFailed: '菜单加载失败，请重新登录',
    loadingStart: '开始加载...',
    prepareMenu: '准备获取菜单',
    menuLoaded: '菜单：加载完成',
    themeUpdated: '主题：已更新',
    baseDataLoaded: '基础数据：加载完成',
    serviceDictLoaded: '微服务字典：加载完成',
    nativeSyncConfig: '原生：同步启动配置',
    titleLoading: '标题加载',
    loadingDomain: '域名：{host}',
    loadingRequestUrl: '请求：{url}',
    loadingProtocol: '协议：{protocol}',
    loadingLoginAddress: '登录地址：{url}',
    loadingLoginUrl: '登录URL：{url}',
  },
  login: {
    title: '登录账号',
    accountPlaceholder: '请输入手机号',
    passwordPlaceholder: '密码',
    rememberMe: '记住账号',
    rememberAccount: '记住账号',
    forgotPassword: '忘记密码？',
    loginButton: '登 录',
    loggingIn: '登录中...',
    loginSuccess: '登录成功',
    otherLogin: '其他登录方式',
    switchLanguage: '中文',
    switchLanguageEn: '英文',
    tenantTitle: '请选择一个租户',
    noAccount: '还没有账号?',
    signUp: '去注册',
    register: '去注册',
    loginFailed: '登录失败，用户名或密码错误',
    phoneRequired: '请输入账号',
    passwordRequired: '请输入密码',
    passwordLength: '密码长度为2-20位',
  },
  register: {
    title: '注册账号',
    accountPlaceholder: '请输入手机号',
    usernamePlaceholder: '请输入用户名',
    phonePlaceholder: '请输入手机号码',
    phoneCorrect: '请输入正确的手机号',
    passwordPlaceholder: '请输入登录密码',
    confirmPlaceholder: '请确认密码',
    confirmPasswordPlaceholder: '请确认密码',
    captchaPlaceholder: '请输入验证码',
    smsCodePlaceholder: '请输入验证码',
    registerButton: '注册账号',
    registering: '注册中...',
    registerSuccess: '注册成功',
    hasAccount: '已有账号？',
    loginButton: '去登录',
    backToLogin: '返回登录',
    sendCode: '发送验证码',
    codeSent: '验证码已发送',
    sendFailed: '发送失败',
    smsSent: '短信验证码已发送',
    smsFailed: '短信发送失败',
    accountRequired: '请输入账号',
    usernameRequired: '请输入用户名',
    phoneRequired: '请输入手机号码',
    captchaRequired: '请输入图形验证码',
    smsCodeRequired: '请输入手机验证码',
    passwordRequired: '请输入密码',
    passwordTooShort: '密码长度不能少于6位',
    passwordMismatch: '两次输入的密码不一致',
    success: '注册成功',
    failed: '注册失败',
  },
  forgotPassword: {
    title: '重置密码',
    phonePlaceholder: '请输入手机号',
    codePlaceholder: '请输入验证码',
    captchaPlaceholder: '请输入图形验证码',
    smsCodePlaceholder: '请输入短信验证码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    nextStep: '下 一 步',
    confirmReset: '确认修改',
    resetting: '提交中...',
    resetSuccess: '重置成功',
    subtitle: '请输入手机号并重置新密码',
    resetButton: '重置密码',
    hasAccount: '想起密码？',
    loginButton: '去登录',
    codeSent: '验证码已发送',
    sendFailed: '发送失败',
    sendCode: '发送验证码',
    captchaRequired: '请输入图形验证码',
    passwordEmpty: '新密码不能为空',
    resetFailed: '重置失败',
    cancel: '取消',
  },
  uploadAvatar: {
    title: '上传头像',
    upload: '上传',
    remove: '移除头像',
    rechoose: '重新选择头像',
    choose: '选择头像',
    uploading: '正在上传头像...',
    uploadSuccess: '头像上传成功！',
    uploadFailed: '头像上传失败！',
    uploadError: '上传头像异常',
    fileTooLarge: '文件大小不能超过5MB',
    removed: '头像已移除',
  },
  changePassword: {
    title: '修改密码',
    currentPassword: '请输入当前密码',
    newPassword: '请输入新密码',
    confirmPassword: '请再次输入新密码',
    updateFailed: '密码修改失败，请重试',
  },
  hotUpdate: {
    writePermissionDenied: '写入下载目录受限，请在系统设置为本应用开启"允许管理所有文件"。',
    storagePermissionPurpose: '检测到新版本后，应用需要存储权限将更新包下载到本地，并在下次重启时完成热更新安装。\n我们只会将更新文件保存到应用使用的更新目录，不会读取您的照片、视频或其他个人文件。\n如果您拒绝授权，本次热更新将无法继续，但应用基础功能仍可正常使用。',    
    storagePermissionApplying: '正在申请存储权限并创建本地更新目录，请稍候。',
    updatePromptTitle: '更新提示',
    newVersionFound: '最新版本 {version}',
    currentVersion: '当前版本：{version}',
    updateDescription: '更新说明：',
    confirmSwitchTitle:'确认切换版本',
    confirmSwitchMsg:'确认切换到版本吗？',
    restartWarning:'更新后应用会重新启动以完成更新',
    restartingUpdateToast:'正在重启应用并更新，请稍候…',
    updatedToast:'已更新到最新版本 {version}',
    currentVersionhis:'当前使用版本',
    retry: '重试',
    downloadFailedTitle: '下载失败',
    downloadFailed: '更新包下载失败，请重试。',
    downloadTimeout: '下载超时，请检查网络后重试。',
    downloadNetworkError: '网络异常，请检查网络后重试。',
    downloadNotFound: '下载地址不可用，请稍后重试。',
    downloadNoSpace: '存储空间不足，请清理空间后重试。',
    downloadStalled: '下载无进度，请重试。'
  },
  logs: {
    needsenabled: '需要开启存储权限',
    storagePermissionMessage:'为了确保日志能够成功写入本地存储并支持后续导出，请开启存储权限。',
    enableStorage: '去开启',
    storagePermissionDialogTitle: '请开启存储权限',
    storagePermissionLater: '暂不授权',
    storagePermissionDialogBody:
      '开启存储权限后，您可以正常保存和导出日志。若未开启，日志功能将无法完整使用。',
    noLogs: '无满足条件的日志',
    title: '日志',
    viewRange: '查看范围',
    refresh: '刷新',
    export: '导出',
    clear: '清除',
    all: '全部',
    error: '错误',
  },
  adpage: {
    skip: '跳过',
  },
  serve: {
    title: '服务器设置',
    current: '当前服务器',
    select: '输入服务器',
    back: '返回',
    placeholder: '请输入服务器地址',
    pleaseinput: '请先输入服务器地址',
    notset: '暂未设置',
    testlink: '连接测试',
    testSuccess: '连接成功',
    testFail: '连接失败',
    timeoutRetry: '请求超时,请重试',
    fetchSuccess: '服务器地址获取成功',
    setSuccess: '服务器设置成功',
    timeout: '请求超时',
    requestFailedCheckAddress: '接口请求失败，请检查地址',
    addressIncorrect: '服务地址不正确',
    invalidAddressFormat: '地址格式错误，请检查'
  },
  indexPage: {
    slogan: '高效协作',
    sloganDesc: '连接团队资源，全面提升管理执行力',
    noAccount: '还没有账户？',
    applyAccount: '申请账号',
    hasAccount: '已有账户？',
    loginNow: '立即登录',
    rememberPassword: '想起密码？',
    goLogin: '去登录',
  },
  exited: {
    toastMessage: '再次滑动退出应用'
  }
};
